import Ract from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import profile from "./Images/Profile.png";
import track from "./Images/Track.png";
import activity from "./Images/Activity.png";
import savedAddress from "./Images/icons8-location-50 (1).png";
import payment from "./Images/Payment.png";
import favroit from "./Images/Favroit.png";
import promotions from "./Images/Promotion.png";
import gift from "./Images/Gift.png";
import { styled } from "@mui/material";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import logout from "./Images/logout.png";
import "../style.css";

const Para = styled(Typography)(({ theme }) => ({
  fontFamily: "Outfit",
  fontStyle: "normal;",
  fontWeight: "400;",
  fontSize: "16px;",
  lineHeight: "160%;",
  letterSpacing: "0.015em;",
  color: "#9EA3AE",
}));
function SideBar({ handleOnClick, currentPage }) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "30px",
        }}
      >
        {[
          { icon: profile, title: "My Profile", path: "my-profile" },
          { icon: track, title: "Track Order", path: "track-order" },
          { icon: activity, title: "My Activity", path: "my-activity" },
          { icon: savedAddress, title: "Saved Address", path: "saved-address" },
          { icon: payment, title: "My Payment", path: "my-payment" },
          { icon: favroit, title: "Favorites", path: "favroit" },
          { icon: promotions, title: "Promotions", path: "promotions" },
          { icon: gift, title: "Gift Card", path: "gift-card" },
        ].map((item) => (
          <Box
            sx={{ textDecoration: "none", cursor: "pointer" }}
            onClick={() => {
              handleOnClick(item.path);
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "150px",
                mt: 2,
              }}
            >
              <img
                src={item.icon}
                style={{
                  height: `${item.icon === savedAddress ? "4vh" : ""}`,
                  marginLeft: `${item.icon === savedAddress ? "10px" : ""}`,
                }}
              />
              <Para
                style={{
                  color: currentPage == item.path ? "#2B817B" : undefined,
                  fontWeight: currentPage == item.path ? "600" : undefined,
                }}
              >
                {item.title}
              </Para>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
}

export default SideBar;
